import React, { useEffect } from 'react';

import { useFilters } from '../hooks/useFilters';
import { scrollToNode } from '../utils/dom';
import { useHash } from '../hooks/useHash';

import BlockContent from './BlockContent';
import Filters from './Filters';

export default function Terms({ section }) {
  const { references } = section;
  const { selectedElement, setSelectedElement } = useFilters(references);

  // SELECT SPECIFIC TERM BASED ON URL HASH
  useHash(references, setSelectedElement);

  useEffect(() => {
    scrollToNode('.body', { offset: -100 });
  }, [selectedElement]);

  return (
    <>
      {section && (
        <div className="terms">
          <Filters
            filters={references}
            handleClick={setSelectedElement}
            selectedElement={selectedElement}
            version="tertiary-text"
            isVertical
          />
          <BlockContent
            content={{ description: selectedElement.markdownContent }}
          />
        </div>
      )}
    </>
  );
}
